import React from 'react';
import { useParams } from 'react-router-dom';

import FormPageNavBar from '@dashboard/components/FormPageNavBar';
import { Button } from '@mui/material';

import ActionsMenu from './ActionsMenu';
import NavBarName from './NavBarName';

type Props = {
  disabled?: boolean;
};
export default function NavigationBar({ disabled }: Props) {
  const { id, platformId } = useParams<{ id: string; platformId: string }>();
  return (
    <FormPageNavBar
      backHref={`/o/${platformId}/templates`}
      leftChildren={<NavBarName templateId={id!} />}
      rightChildren={
        <>
          <ActionsMenu templateId={id!} />
          <Button disabled={disabled} form="wp-form" type="submit" variant="contained" color="primary">
            Save
          </Button>
        </>
      }
    />
  );
}
